var countryNew = document.getElementById("country-new");
var provinceNew = document.getElementById("province-new");
var zipNew = document.getElementById("postcode-new");
var response = document.getElementById("wrapper-response");
var shipTo = document.getElementById("shipTo");
var endPoint = 'https://api.pinkyparadise.com';
var defaultFetchParam = { method: 'GET',
               headers: new Headers({
					'Content-Type': 'application/json'
				}),
               mode: 'cors',
               cache: 'default' };
  
  updateProvince(countryNew);
  selectorSetup();
  defaultCountryByIP();
  
  const getShippingRates = async function(zip, state, country) {
    	const url = encodeURI(`shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${state}`);
        const result = await fetch(`/cart/shipping_rates.json?${url}`, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        });

        return result.json();
  }

  const startGetCCS = async function(zip, state, country) {
    response.innerHTML = "";
    var countryVal = countryNew.options[countryNew.selectedIndex].value;
    var provinceVal = provinceNew.options[provinceNew.selectedIndex].value;
    var zipVal = zipNew.value;
	
    //console.log("countryVal", countryVal);
    //console.log("provinceVal", provinceVal);
    //console.log("zipVal", zipVal);
    
    const rates = await getShippingRates(zipVal, provinceVal, countryVal);
    
 //   console.log("rates", rates);
//     console.log("rates.length", rates.length);
//     rates.forEach((entry) => {
//         console.log(entry);
//     });
//    console.log("rates.shipping_rates", rates.shipping_rates);
    
    var shipRates = document.createElement("p");
    shipRates.id = "shipping-rates-feedback";
    
    if(rates.shipping_rates != undefined){
      shipRates.className = "text-left success";
      var shipRatesSpan = document.createElement("span");
      shipRatesSpan.className = "shipping-calculator__carriers";
      shipRatesSpan.innerHTML = "Available shipping carriers :<br/>";
      shipRates.appendChild(shipRatesSpan);
      //console.log("rates.shipping_rates.length", rates.shipping_rates.length);
      rates.shipping_rates.forEach((entry) => {
          //console.log("entry", entry);
          shipRates.innerHTML += '-' + entry.name + ' :' + '<span class="product-price__price"><span class="money" data-currency-usd="$'+entry.price+' USD" data-currency="USD">$'+entry.price+' USD</span></span>.<br>'
          //shipRates.appendChild(dataEntry);
      });
      
    }
     if(rates.zip != undefined){
       shipRates.className = "text-left error";
       shipRates.innerHTML += "Error : zip " + rates.zip;
     }
     if(rates.error != undefined){
       shipRates.className = "text-left error";
       if(rates.error == "This cart does not require shipping"){
         shipRates.innerHTML += "Error : Please add any item to your cart...";
       }else{
         shipRates.innerHTML += "Error : error " + rates.error;
       }
     }
    
    response.appendChild(shipRates); 
  }

  function selectorSetup() {
    // Listening to changes to any element with a "data-province" attribute
    countryNew.addEventListener('change', function(e) {
        updateProvince(countryNew);
    }, false);
   }
//     var countrySelecters = document.querySelectorAll('[name="address[country]"]');
//     console.log("countrySelecters", countrySelecters);
//     if (countrySelecters.length > 0) {
//       // Arrays of the values for current country and province settings, when the page first loads
//       var selectedCountry = [{% for address in customer.addresses %}'{{ address.country }}'{% if forloop.last != true %},{% endif %}{% endfor %}];
//       var selectedProvince = [{% for address in customer.addresses %}'{{ address.province }}'{% if forloop.last != true %},{% endif %}{% endfor %}];
//       // Looping through all of the country select tags
//       for (var i = 0; i < countrySelecters.length; i++) {
//         var countrySelect = countrySelecters[i];
//         var provinceSelect = document.getElementById(countrySelect.getAttribute('data-provinces'));
//         if (provinceSelect) {
//           // Setting up the select boxes with the correct current data
//           preSelect(countrySelect,selectedCountry[i]);
//           updateProvince(countrySelect);
//           preSelect(provinceSelect,selectedProvince[i]);
//         }
//       }
//     }
  
 
  // Updates the province select box, if required
  function updateProvince(countrySelect) {
    
    var provinceObj = JSON.parse(countrySelect.options[countrySelect.selectedIndex].dataset.provinces);
    // Does the chosen country have provinces?
    if (provinceNew && provinceObj.length > 0) {
      var options = '';
      for (var i = 0; i < provinceObj.length; i++) {
        options = options + '<option value="' + provinceObj[i][0] +'">' + provinceObj[i][1] + '</option>\n';
      }
      provinceNew.removeAttribute('disabled');
      provinceNew.innerHTML = options;
    } else {
      provinceNew.setAttribute('disabled','disabled');
      provinceNew.innerHTML = '<option value="">No provinces for the current country</option>';
    }
  }
  // This is passed a select box and a value. It attempts to find the value within the select box, then change that option tag to "selected".
  function preSelect(obj,value) {
    if (obj && value !== '') {
      for (var i = 0; i < obj.length; i++) {
        var option = obj[i];
        if (option.text === value) {
          option.setAttribute('selected','selected');
        } else {
          option.removeAttribute('selected');
        }
      }
    }
  }
  
  function defaultCountryByIP(){
//       console.log("---------------DEFAULT COUNTRY BY IP START----------------");
      url = endPoint + "/public" + "/geoip";
      fetch(url, defaultFetchParam)
      .then(function(response) {
        return response.json();
      }).then(function(result) {
//         console.log("result defaultCountryByIP", result)
        if (result.status == "00") {        
//           console.log("Country code is", result.countryCode);
//           countryCode = result.countryCode;
//           console.log("result.countryName", result.countryName);
//           console.log("result.isShipTo", result.isShipTo);
          if(result.isShipTo == "0"){
            shipTo.innerHTML = '<center><h2 style="font-size: 36px; color: #553f3d;">SORRY :(  SHIPPING IS NOT AVAILABLE TO '+ result.countryName.toUpperCase() +'</h2></center>';
          }else {
            shipTo.innerHTML = '<center><h2 style="font-size: 36px; color: #553f3d;" >WE DELIVER TO '+result.countryName.toUpperCase()+'</h2></center>';
          }
        } else {
          //console.log("Failed to retrieve client's IP address.")
        }
      });
//       console.log("---------------DEFAULT COUNTRY BY IP END----------------");
  }